import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          applicationId: Yup.string()
                                                            .required('Required'),
                                          accountApplicationStatus: Yup.string()
                                                                       .required('Required'),
                                      });
